import { getOrgDetails, getOrgSettings, getWhiteLabelAppInfo } from '@api/api'
import { OrgDetailsResponse } from '@api/api.types'
import { queryOptions } from '@tanstack/react-query'

export const ORG_SETTINGS_QUERY = 'orgSettings'

export const orgSettingsQueryOptions = (locationId?: string) =>
  queryOptions({
    queryKey: [ORG_SETTINGS_QUERY, locationId],
    queryFn: async () => {
      const { data } = await getOrgSettings(locationId)
      return data
    },
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: !!locationId,
  })

type OrgDetailsProps<TData = OrgDetailsResponse> = {
  select?: (data: OrgDetailsResponse) => TData
  organizationId?: string
}

export const ORG_DETAILS_QUERY = 'orgDetails'

export const orgDetailsQueryOptions = <TData = OrgDetailsResponse>({
  organizationId,
  select,
}: OrgDetailsProps<TData>) =>
  queryOptions({
    queryKey: [ORG_DETAILS_QUERY, organizationId],
    queryFn: async () => {
      try {
        const { data } = await getOrgDetails(organizationId!)
        return data
      } catch (error) {
        //if org details fails we don't want suspense error boundary to catch it, let the user proceed
        return { data: {} } as OrgDetailsResponse
      }
    },
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: !!organizationId,
    select,
  })

export const whiteLabelDetailsQueryOptions = queryOptions({
  queryKey: ['whiteLabelDetails'],
  queryFn: async () => {
    const res = await getWhiteLabelAppInfo()
    return res.data
  },
})
